import { apiGet, apiPost } from '../utils/api'
import Hotjar from '@hotjar/browser'

export const getSettingConfigAPI = (groupName) => {
  return apiGet(`mgmt/shopSettings/group/${groupName}`)
}

export const updateSettingConfigAPI = (data, groupName) => {
  return apiPost(`mgmt/shopSettings/update/${groupName}`, data)
}

export const updateReportingConfigAPI = (data, groupName) => {
  Hotjar.event('update_reporting_config')
}



// WEBPACK FOOTER //
// ./src/api/shopSetting.js